(() => {
  'use strict';
  const KEY = '__pbSunsetFilm';
  if (window[KEY]) { window[KEY].init(); return; }
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(video) {
    if (instances.has(video)) return;
    const frame = video.closest('[data-pb-sunset-frame]');
    const button = frame?.querySelector('[data-pb-sunset-toggle]');
    if (!frame || !button) return;
    const listeners = [];
    const listen = (target, type, fn) => {
      target.addEventListener(type, fn);
      listeners.push(() => target.removeEventListener(type, fn));
    };
    let visible = false, userPaused = video.dataset.pbSunsetPaused === 'true', pending = false, rejected = false, failed = false, destroyed = false;
    const otherFilms = [...document.querySelectorAll('[data-pb-user-film]')];
    const motionBlocked = () => reduced.matches || document.documentElement.classList.contains('dm-paused');
    const inViewport = () => {
      const r = video.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
    };
    const eligible = () => !destroyed && !failed && visible && video.isConnected && !document.hidden && !motionBlocked() && !userPaused && !otherFilms.some(other => !other.paused && !other.ended);
    const syncButton = () => {
      const blocked = motionBlocked();
      const playing = !video.paused && !video.ended;
      button.disabled = blocked || failed;
      button.textContent = failed ? 'Video unavailable' : blocked ? 'Motion paused' : playing ? 'Pause video' : 'Play video';
      button.setAttribute('aria-label', failed ? 'Sunset video unavailable; photograph shown' : blocked ? 'Sunset video paused by motion preference' : playing ? 'Pause sunset video' : 'Play sunset video');
      button.setAttribute('aria-pressed', String(playing));
    };
    const reconcile = () => {
      if (!eligible()) { video.pause(); syncButton(); return; }
      if (!video.paused || pending || rejected) { syncButton(); return; }
      video.muted = true;
      pending = true;
      Promise.resolve(video.play()).then(() => {
        pending = false;
        if (!eligible()) video.pause();
        syncButton();
      }).catch(() => {
        pending = false;
        if (eligible()) rejected = true;
        syncButton();
      });
    };
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    button.hidden = false;
    listen(button, 'click', () => {
      if (motionBlocked() || failed) return;
      userPaused = !video.paused || pending;
      video.dataset.pbSunsetPaused = String(userPaused);
      rejected = false;
      visible = inViewport();
      reconcile();
    });
    listen(video, 'play', () => { if (!eligible()) video.pause(); syncButton(); });
    listen(video, 'playing', () => {
      if (!eligible()) { video.pause(); return; }
      frame.dataset.pbSunsetFrame = 'true';
      syncButton();
    });
    ['pause','ended'].forEach(type => listen(video, type, syncButton));
    const mediaFailed = () => {
      failed = true;
      frame.dataset.pbSunsetFrame = 'false';
      video.pause();
      syncButton();
    };
    listen(video, 'error', mediaFailed);
    video.querySelectorAll('source').forEach(source => listen(source, 'error', mediaFailed));
    otherFilms.forEach(other => ['play','pause','ended'].forEach(type => listen(other, type, reconcile)));
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.target === video) visible = entry.isIntersecting && entry.intersectionRatio >= .25; });
      reconcile();
    }, {threshold:[0,.25]}) : null;
    observer?.observe(video);
    const mutations = new MutationObserver(reconcile);
    mutations.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    listen(reduced, 'change', reconcile);
    listen(document, 'visibilitychange', reconcile);
    const destroy = () => {
      destroyed = true;
      video.pause();
      observer?.disconnect();
      mutations.disconnect();
      listeners.forEach(remove => remove());
      button.hidden = true;
      instances.delete(video);
    };
    instances.set(video, {destroy});
    reconcile();
  }
  const init = () => document.querySelectorAll('[data-pb-sunset-loop]').forEach(mount);
  const destroy = container => [...instances].forEach(([video, instance]) => { if (!container || container.contains(video)) instance.destroy(); });
  window[KEY] = {init, destroy};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  window.addEventListener('pagehide', () => destroy());
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
})();
